import { render, staticRenderFns } from "./PeopleList.vue?vue&type=template&id=4314c090&scoped=true&"
import script from "./PeopleList.vue?vue&type=script&lang=js&"
export * from "./PeopleList.vue?vue&type=script&lang=js&"
import style0 from "./PeopleList.vue?vue&type=style&index=0&id=4314c090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4314c090",
  null
  
)

export default component.exports